import { createContext, useContext } from 'react'

export const FXContext = createContext({
  isActive: true
})

export const useFXContext = () => useContext(FXContext)
